import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '../../../hooks/@lore/query-connect';
import ReminderDialogTemplate from '../_common_reminders/ReminderDialogTemplate';

Dialog.propTypes = {
  question: PropTypes.object.isRequired
};

export default function Dialog(props) {
  const { question } = props;

  const reminders = useConnect('reminder.find', {
    where: {
      eager: {
        $where: {
          questionId: question.id
        }
      }
    }
  });

  const user = useConnect('user.byId', {
    id: question.data.userId
  });

  let _data = {
    questionId: question.id,
    recipientId: user.id,
    type: 'Pending'
  };

  return (
    <ReminderDialogTemplate
      title="Send reminder to respond"
      subtitle={(
        <span>
          This will send an email to {user.data.firstName} nudging them respond to the invitation either
          by expressing interest or declining.
        </span>
      )}
      reminders={reminders}
      _data={_data}
      MAX_COUNT={2}
      onClose={props.onClose}
    />
  );
};
